module.exports = __webpack_public_path__ + "static/media/Shade1.16e97fa0.jpg";